import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'
// *** Lazy Load Base Components ***
const BaseTable = () => import('./BaseTable.vue')
const BaseImageUpload = () => import('./BaseImageUpload.vue')
const BaseSwitch = () => import('./BaseSwitch.vue')
const BaseConfirmDialog = () => import('./BaseConfirmDialog.vue')
const BaseInput = () => import('./BaseInput.vue')
const BaseInputColorPicker = () =>
  import('./BaseInputColorPicker.vue')
const BaseMultiInput = () => import('./BaseMultiInput.vue')
const DatePicker = () => import('./DatePicker.vue')
const Editor = () => import('./Editor.vue')
const BaseLabel = () => import('./BaseLabel.vue')
const Header = () => import('./Header.vue')
const MainLayout = () => import('./MainLayout.vue')
const BaseDialogImageCarousels = () =>
  import('./BaseDialogImageCarousels')
const ButtonFooter = () => import('./ButtonFooter')
const BaseLazyDropdown = () => import('./BaseLazyDropdown')
const BaseTimePicker = () => import('./BaseTimePicker.vue')
const DatePickerTime = () => import('./DatePickerTime.vue')

Vue.component('validation-provider', ValidationProvider)
Vue.component('BaseTable', BaseTable)
Vue.component('BaseImageUpload', BaseImageUpload)
Vue.component('BaseSwitch', BaseSwitch)
Vue.component('BaseConfirmDialog', BaseConfirmDialog)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseInputColorPicker', BaseInputColorPicker)
Vue.component('BaseMultiInput', BaseMultiInput)
Vue.component('DatePicker', DatePicker)
Vue.component('Editor', Editor)
Vue.component('BaseLabel', BaseLabel)
Vue.component('Header', Header)
Vue.component('MainLayout', MainLayout)
Vue.component('BaseDialogImageCarousels', BaseDialogImageCarousels)
Vue.component('ButtonFooter', ButtonFooter)
Vue.component('BaseLazyDropdown', BaseLazyDropdown)
Vue.component('BaseTimePicker', BaseTimePicker)
Vue.component('DatePickerTime', DatePickerTime)

export {
  BaseImageUpload,
  BaseTable,
  BaseSwitch,
  BaseConfirmDialog,
  BaseInput,
  BaseInputColorPicker,
  BaseMultiInput,
  DatePicker,
  Editor,
  BaseLabel,
  Header,
  MainLayout,
  BaseDialogImageCarousels,
  ButtonFooter,
  BaseLazyDropdown,
}
